/* eslint no-unused-vars:0 */
import { h } from 'preact';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledImageContainer = styled.div`
  ${({isInviteReflow, vertical}) => isInviteReflow ? `
    min-width: 137px;
    min-height: 83px;  
    margin: 6px auto 16px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    max-width: calc(100vw - 20px);
    @media screen and (max-height: ${vertical - 1}px) { min-height: fit-content; }
    @media screen and (max-width: 250px) { min-width: unset;}
  ` : `
    min-width: 137px;
    min-height: 83px;
    margin: 30px auto 42px;
  `};
`;
const StyleImage = styled.img`
  ${({ isInviteReflow }) => isInviteReflow ? `
    border: 0;
    margin: unset;
    display: block;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  ` : `
    border: 0px;
    margin: 30px auto 42px;
    display: table;
    vertical-align: middle;
  `};
`;

export default function ImageSection(props) {
  return (
    <StyledImageContainer className="imageContainer" isInviteReflow={props.isInviteReflow} vertical={props.vertical}>
      {props.imageSrc && props.imageSrc.url ? (
        <StyleImage alt={props.imageAlt} src={props.imageSrc.url} onLoad={(e) => props.onImageLoad?.()}
          isInviteReflow={props.isInviteReflow} />
      ) : null}
    </StyledImageContainer>
  );
}

ImageSection.propTypes = {
  imageSrc: PropTypes.object,
};

ImageSection.defaultValues = {
  imageSrc: null,
};
